import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import { getImageSrc } from "../../../utils/imageUrl";

import "./card.less"; // Asegúrate de que la ruta sea correcta

// 1. Define una interfaz para las props del componente Card
interface CardProps {
  id: string; // Asumo que id es una cadena (el ID del producto)
  imagen: string | string[]; // Puede ser una URL individual o un array de URLs
  name: string; // Asumo que name es una cadena
  articulo: string; // Asumo que articulo es una cadena (la URL del artículo)
  rating: number; // Asumo que rating es un número (la calificación)
  numReviews: number; // Asumo que numReviews es opcional y es un número (cantidad de reseñas)
  price: number; // Asumo que price es opcional y es un número (el precio del producto)
  // Si tuvieras más props, las añadirías aquí.
  // Por ejemplo, si los iconos de estrella fueran una prop:
  // rating: number; // Para la cantidad de estrellas
}

// 2. Asigna la interfaz a las props del componente
//export default function card({ imagen, name, articulo }: CardProps) { // Puedes usar 'card' o 'Card'

export default function Card({
  id,
  imagen,
  name,
  articulo,

  price,
}: CardProps) {
  const spans: React.JSX.Element[] = [];
  const cantidadDeVeces = 5; // Cambia este valor según la cantidad de veces que quieras repetir el span

  for (let index = 0; index < cantidadDeVeces; index++) {
    spans.push(
      <span key={index}>
        <FontAwesomeIcon icon={faStar} />
      </span>
    );
  }

  const rawImage = Array.isArray(imagen) ? imagen[0] : imagen;
  const src = getImageSrc(rawImage);

  return (
    <div className="card">
      <div className="img-card">

        <Link className="img-card" to={`/productos/${id}`}>
          {/* <Link className="img-card" to={`/productos/category/plc/${id}`}> */}
          <img className="medium" src={src} alt={name} />
        </Link>
      </div>
      <div className="content-card">
        {" "}
        <Link to={articulo}>
          <h3>{name}</h3>
        </Link>
        <h2 className="price">
          $ {price} <small>00</small>
        </h2>

        <Link to={`/product/${id}`} className="btn buy">
          comprar
        </Link>
        <div className="rating">{spans}</div>
      </div>
    </div>
  );
}
